import type { AxiosError } from 'axios';
import type { ErrorResponse } from '../types/api/ErrorResponses';

export const getApiErrorMessage = (error: unknown): string | undefined => {
  const body = (error as AxiosError<ErrorResponse> | undefined)?.response?.data;
  return body?.errors?.[0]?.message ?? body?.error?.message;
};
